import React, { useEffect, useState } from "react";
import { useT } from "../i18n/LanguageContext";

export const StickyMobileCTA = ({ onReserve }) => {
  const { t } = useT();
  const x = t.sticky;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  return (
    <div
      className={`fixed bottom-[64px] inset-x-0 z-40 sticky-bar md:hidden transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-[200%] opacity-0"
      }`}
      data-testid="sticky-mobile-cta"
    >
      <div className="px-4 py-3 flex items-center justify-between gap-3">
        <div className="flex flex-col leading-tight">
          <span className="text-[10px] uppercase tracking-[0.2em] text-[var(--pn-amber)]">
            {x.eyebrow}
          </span>
          <span className="font-display italic text-[14px] text-[var(--pn-cream)]/85">
            {x.line}
          </span>
        </div>
        <a
          href="https://pnssm.pro/5sq02s5"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-primary !py-3 !px-5 !text-[14px]"
          data-testid="sticky-cta-button"
        >
          {x.btn}
          <span aria-hidden>→</span>
        </a>
      </div>
    </div>
  );
};
